import {ApiSortsDerived} from '@/api/meta/odata';
import {createVersionedStorage} from './types';
import {boolToDisplay, fulltextToDisplay, toDisplay} from '@/util/store';
import Correction, {ApiCorrection, CorrectionFilters} from '@/model/Correction';
import {getCorrections} from '@/api/module/correction';
import {ValueType} from '@/api/meta/filters';

const useCorrectionsStore = createVersionedStorage<
  CorrectionFilters, ApiSortsDerived<ApiCorrection>, Correction[]
>('corrections', {
  fetchFn: getCorrections,
  defaultData: [],
  defaultFilters: {
    Fulltext$Fulltext: {
      words: [],
      fields: [
        {
          path: ['BelegNr'],
          valueType: ValueType.NumberStartsWith,
        },
        {
          path: ['Bediener'],
          valueType: ValueType.StringContains,
        },
      ],
    },
    Erledigt: false,
  },
  defaultSorts: [],
  formatter: {
    Fulltext$Fulltext: fulltextToDisplay,
    Datum$From: toDisplay('Datum von'),
    Datum$To: toDisplay('Datum bis'),
    Bediener: toDisplay('Bediener'),
    Erledigt: (val) => {
      if (val === undefined) return undefined;
      return boolToDisplay('offen', 'erledigt')(!val);
    },
  },
});

export default useCorrectionsStore;
